import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import { selectActiveTableRowsExist } from 'services/selectedTableCells/selectors';

interface OwnProps {
    children: React.ReactElement;
}

interface ConnectedProps {
    activeTableRowsExist?: boolean;
}

type Props = OwnProps & ConnectedProps;

export class ActiveTableRowsExistGateComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { activeTableRowsExist, children } = this.props;
        if (!activeTableRowsExist) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    activeTableRowsExist: selectActiveTableRowsExist,
});

export default connect(mapStateToProps)(ActiveTableRowsExistGateComponent);
